module.exports = __webpack_public_path__ + "static/img/szafa_27_kopia.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_27_kopia.svg
// module id = vnbj
// module chunks = 0